// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3hX-H","legacyBtn":"MutateMid_legacyBtn__3zZAB"};